module.exports = __webpack_public_path__ + "img/hopital-general-juif.ef9528af.png";